import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { RegisterService } from "../register.service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  FormControl,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ToastrService } from "ngx-toastr";
import { BreadcrumbService } from "../../../shared/services/breadcrumb.service";
import { EventKindEnum, InvitedKindEnum } from "../../../shared/models";
import { GUEST } from "../../../shared/constants/constants";
import { GoogleTagManagerService } from "../../../shared/services/googletagmananer.service";

@Component({
  selector: "app-form-register",
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, TranslateModule],
  templateUrl: "./form-register.component.html",
  styleUrl: "./form-register.component.scss",
})
export class FormRegisterComponent {
  token = "";
  tokenParticipant = "";
  anyErrors = false;
  mainObj: any;
  participantType: InvitedKindEnum = InvitedKindEnum.Person;
  eventName: string;
  eventDescription: string;
  eventDates: any[] = [];
  eventAddress: string;
  eventType: string;
  eventRegisterForm: FormGroup;
  EventKindEnum: EventKindEnum;
  errorInvalidFields: string;
  warningError: string;
  realCompany: string;
  public validate = true;

  constructor(
    private route: ActivatedRoute,
    private registerService: RegisterService,
    private breadcrumbService: BreadcrumbService,
    private translateService: TranslateService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private router: Router,
    private gtmService: GoogleTagManagerService
  ) { }

  ngOnInit() {
    this.route.parent?.params.subscribe((params) => {
      if (params["token"]) {
        this.token = params["token"];
      }
      if (params["tokenParticipant"]) {
        this.tokenParticipant = params["tokenParticipant"];
      }
    });
    this.initForm();
    this.getEvent();
    this.errorInvalidFields = this.translateService.instant(
      "errors.check_mandatory_fields"
    );
    this.warningError = this.translateService.instant("warning");
  }

  initForm() {
    this.eventRegisterForm = this.fb.group({
      name: ["", Validators.required],
      surname: ["", Validators.required],
      email: [
        "",
        [Validators.required, Validators.email],
      ],
      phoneNumber: [""],
      profession: ["", Validators.required],
      company: [""],
      city: ["", Validators.required],
    });
  }

  patchForm(participant: any, isGuest: boolean = false) {
    const name = participant?.name ?? '';
    const surname = participant?.surname ?? '';
    const email = participant?.email ?? '';
    const phoneNumber = participant?.phone ?? '';
    const profession = participant?.role ?? '';
    let company = participant?.company ?? '';
    if (this.participantType === InvitedKindEnum.Dealer) {
      this.realCompany = participant?.company ?? ''
      company = '';
    }
    const city = participant?.city ?? '';

    this.eventRegisterForm.patchValue({
      name,
      surname,
      email,
      phoneNumber,
      profession,
      company,
      city
    });

    if (isGuest) {
      return
    }


    if (name || this.isOWA()) {
      this.eventRegisterForm.get("name")?.markAsTouched();
      this.eventRegisterForm.get("name")?.disable();
    }

    if (surname || this.isOWA()) {
      this.eventRegisterForm.get("surname")?.markAsTouched();
      this.eventRegisterForm.get("surname")?.disable();
    }

    if (email || this.isOWA()) {
      this.eventRegisterForm.get("email")?.markAsTouched();
      this.eventRegisterForm.get("email")?.disable();
    }

    if (phoneNumber) {
      this.eventRegisterForm.get("phoneNumber")?.markAsTouched();
      this.eventRegisterForm.get("phoneNumber")?.disable();
    }

    if (profession) {
      this.eventRegisterForm.get("profession")?.markAsTouched();
      this.eventRegisterForm.get("profession")?.disable();
    }

    if (company && this.participantType === InvitedKindEnum.Person ) {
      this.eventRegisterForm.get("company")?.markAsTouched();
      this.eventRegisterForm.get("company")?.disable();
    }
    
    if (city) {
      this.eventRegisterForm.get("city")?.markAsTouched();
      this.eventRegisterForm.get("city")?.disable();
    }

    // if is a open week architect
    if (this.isOWA()) {
      this.eventRegisterForm.addControl("selectDate", new FormControl('', [Validators.required]));
    }

    this.eventRegisterForm.updateValueAndValidity();

  }

  getEvent() {
    if (this.tokenParticipant === GUEST) {
      this.registerService.getEventForRegisterGuest(this.token).subscribe({
        next: (v) => {
          const event = v.data;
          this.eventName = event?.title ?? '';
          this.eventDescription = event.description;
          this.eventDates = event.dates;
          this.eventAddress = event.store?.address;

          this.eventType = event.type;
          let pretitle = this.translateService.instant("events.pre_title");
          this.changeBreadcrumb(this.eventName, pretitle, false, "");
          this.patchForm(this.mainObj, true);

          this.gtmService.pushEvent('pv_iscrizione_evento', {
            value: this.eventName
          });
        },
        error: (e) => {
          this.anyErrors = true;
          console.error(e);
          let preTitle = this.translateService.instant("errors.title");
          let title = this.translateService.instant("errors.generic_error");

          if (e.status === 404) {
            preTitle = this.translateService.instant("events.title");
            title = this.translateService.instant("errors.event_not_found");
          }

          this.changeBreadcrumb(title, preTitle, false, "");
        },
      });
    } else {
      this.registerService
        .getEventForRegister(this.token, this.tokenParticipant)
        .subscribe({
          next: (v) => {
            const data = v.data;
            this.mainObj = data.participants;
            const event = this.mainObj.event;
            this.participantType = this.mainObj.type;
            this.eventName = event?.title ?? '';
            this.eventDescription = event.description;
            this.eventDates = event.dates;
            this.eventAddress = event.store?.address;
            this.eventType = event.type;
            let pretitle = this.translateService.instant("events.pre_title");
            this.changeBreadcrumb(this.eventName, pretitle, false, "");

            this.patchForm(this.mainObj, false);
            // this.eventRegisterForm.get("company")?.disable();

          },
          error: (e) => {
            this.anyErrors = true;
            console.error(e);
            let preTitle = this.translateService.instant("errors.title");
            let title = this.translateService.instant("errors.generic_error");

            if (e.status === 404) {
              preTitle = this.translateService.instant("events.title");
              title = this.translateService.instant("errors.event_not_found");
            }

            this.changeBreadcrumb(title, preTitle, false, "");
          },
        });
    }

  }

  buildRequestTemplate(
    email: any,
    name: string,
    surname: string,
    role: string,
    city: string,
    phone: string | null,
    company: string,
    date_id: number
  ) {
    let request = {};
    return (request = {
      email: email,
      name: name,
      surname: surname,
      role: role,
      city: city,
      phone: phone,
      company: company,
      date_id: date_id,
    });
  }

  storeRegisterForEvent() {

    let formValid = this.eventRegisterForm.valid;

    const allDisabled = Object.values(this.eventRegisterForm.controls).every(control => control.disabled);

    if (allDisabled) {
      Object.values(this.eventRegisterForm.controls).forEach(control => control.enable());
      this.eventRegisterForm.updateValueAndValidity();
      formValid = this.eventRegisterForm.valid;
      Object.values(this.eventRegisterForm.controls).forEach(control => control.disable());
    }

    if (!formValid) {
      this.validate = true;
      
      this.toastrService.error(this.errorInvalidFields, this.warningError);
    } else {
      this.validate = false;

      const email = this.eventRegisterForm.get("email")?.value || null;
      const name = this.eventRegisterForm.get("name")?.value || null;
      const surname = this.eventRegisterForm.get("surname")?.value || null;
      let phone = null;
      const phoneNumber = this.eventRegisterForm.get("phoneNumber")

      if (phoneNumber) {
        phone = phoneNumber?.value ? `${phoneNumber.value}` : null
      }
      const role = this.eventRegisterForm.get("profession")?.value || null;
      const company = this.eventRegisterForm.get("company")?.value || null;
      const city = this.eventRegisterForm.get("city")?.value || null;
      const date_id = this.eventRegisterForm.get("selectDate")?.value || null;

      const body = this.buildRequestTemplate(
        email,
        name,
        surname,
        role,
        city,
        phone,
        company,
        date_id
      );

      if (this.tokenParticipant === GUEST) {
        this.registerService
          .storeRegisterForGuest(this.token, body)
          .subscribe({
            next: (response) => {
              const data = response?.data ?? null;
              if (data) {
                window.location.href = data.ref_link;
              } else {
                throw new Error('no data found on response', response)
              }
            },
            error: (e) => console.error(e),
          });
      }
      else {
        this.registerService
          .storeRegisterForEvent(this.token, this.tokenParticipant, body)
          .subscribe({
            next: (response) => {
              const data = response?.data ?? null;
              if (data) {
                if (this.participantType === InvitedKindEnum.Person) {
                  this.router.navigate([`/events/${this.token}/participants/${this.tokenParticipant}`]);
                } else {
                  window.location.href = data.ref_link;
                }
              } else {
                throw new Error('no data found on response', response)
              }
            },
            error: (e) => console.error(e),
          });
      }
    }
  }

  changeBreadcrumb(
    title: string,
    preTitle: string,
    eventDetailButtons: boolean,
    token: string
  ) {
    // Cambia la proprietà usando il servizio
    this.breadcrumbService.changeBreadCrumbProps({
      title,
      preTitle,
      eventDetailButtons,
      token,
    });
  }

  isOWA() {
    return this.eventType === EventKindEnum.OWA;
  }

  isDealer() {
    return this.participantType === InvitedKindEnum.Dealer;   
  }
}
